import { TOKEN_COLORS } from '../constants/colors';
import type { CostBreakdown } from '../types/unified-analytics';

export interface CostBreakdownSlice {
  name: string;
  value: number;
  color: string;
}

export function buildCostBreakdownSlices(breakdown: CostBreakdown): CostBreakdownSlice[] {
  return [
    { name: 'Input', value: breakdown.input_cost, color: TOKEN_COLORS.input },
    { name: 'Output', value: breakdown.output_cost, color: TOKEN_COLORS.output },
    { name: 'Reasoning', value: breakdown.thoughts_cost, color: TOKEN_COLORS.thoughts },
    { name: 'Cached', value: breakdown.cached_cost, color: TOKEN_COLORS.cached },
    {
      name: 'Cache writes',
      value: breakdown.cache_write_cost ?? 0,
      color: TOKEN_COLORS.cacheWrites,
    },
    {
      name: 'Cache storage',
      value: breakdown.cache_storage_cost ?? 0,
      color: TOKEN_COLORS.cacheStorage,
    },
    { name: 'Tools', value: breakdown.tool_cost, color: TOKEN_COLORS.tools },
    { name: 'Images', value: breakdown.image_cost, color: TOKEN_COLORS.images },
    { name: 'Videos', value: breakdown.video_cost, color: TOKEN_COLORS.videos },
  ].filter((slice) => slice.value > 0);
}

// Below this share a slice's label collides with its neighbours; the legend carries it instead.
const MIN_LABELLED_SHARE = 0.03;

export function sliceLabel({ name, percent }: { name: string; percent: number }): string {
  return percent >= MIN_LABELLED_SHARE ? `${name} ${(percent * 100).toFixed(0)}%` : '';
}
